import { render, staticRenderFns } from "./CadastrosMotivos.vue?vue&type=template&id=179396ea"
import script from "./CadastrosMotivos.vue?vue&type=script&lang=js"
export * from "./CadastrosMotivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports